export const SET_LOADING = '@manufactureVariants/SET_LOADING';
export const SAVE_DATA = '@manufactureVariants/SAVE_DATA';
export const SET_FILTER = '@manufactureVariants/SET_FILTER';
export const SET_ACTIVE_PAGE = '@manufactureVariants/SET_ACTIVE_PAGE';
export const VM_LOADING = '@manufactureVariants/VM_LOADING';
export const BTN_LOADING = '@manufactureVariants/BTN_LOADING';
export const SET_VM_OPTIONS = '@manufactureVariants/SET_VM_OPTIONS';
export const SET_VM_SELECTED_OPTION = '@manufactureVariants/SET_VM_SELECTED_OPTION';



// WEBPACK FOOTER //
// ./src/Modules/ManufactureVariants/constants.js